import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import DatePicker from 'react-date-picker'
import { DocumentDownloadIcon, QuestionMarkCircleIcon, SearchIcon } from '@heroicons/react/solid';
import { convert, formatDate } from '../../utils/convertDate';
import { FormatMoney } from '../../utils/formatMoney';
import GeneralTable from '../../components/GeneralTable';
import { useNavigate } from 'react-router-dom';
import TreasuryBillClass from '../../services/treasuryBill';

const oldFrom = new Date().setDate(new Date().getDate() - 7);
const defaultTo = formatDate(new Date());
const longNew = formatDate(defaultTo);
const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
const longDate = formatDate(defaultFrom);

const TreasuryLiquidation = () => {
    const navigate = useNavigate()

    const [searchLiquidations, setSearchLiquidations] = useState("")
    const [liquidationData, setLiquidationData] = useState([])
    const [to, setTo] = useState(convert(longNew));
    const [from, setFrom] = useState(convert(longDate));
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    });

    // Enhanced state for pagination
    const [pageIndex, setPageIndex] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPreviousPage, setHasPreviousPage] = useState(false);
    const itemsPerPage = 10;

    // Pagination handlers
    const prevPage = () => {
        if (pageIndex > 1) {
            setPageIndex(pageIndex - 1);
        }
    };

    const nextPage = () => {
        if (hasNextPage) {
            setPageIndex(pageIndex + 1);
        }
    };

    const handleSetPageIndex = (page) => {
        setPageIndex(page);
    };

    // Define columns - Fixed duplicate keys and structure
    const columns = [
        { key: 'security', header: 'Security' },
        { key: 'faceValue', header: 'Face Value', render: (item) => FormatMoney(item.faceValue, 'NGN') },
        { key: 'customerName', header: 'Customer Name' },
        { key: 'accountNumber', header: 'Account Number' },
        { key: 'emailAddress', header: 'Email Address' },
        { key: 'tenor', header: 'Tenor', render: (item) => item.tenor + " " + "days" },
        { key: 'discountRate', header: 'Discount Rate', render: (item) => item.discountRate + "%" },
        { key: 'yield', header: 'Yield', render: (item) => item.yield + "%" || "-" },
        { key: 'redemptionValue', header: 'Redemption Value', render: (item) => FormatMoney(item.redemptionValue, 'NGN') },
        { key: 'consideration', header: 'Consideration', render: (item) => FormatMoney(item.consideration, 'NGN') },
        { key: 'settlementDate', header: 'Settlement Date', render: (item) => item.settlementDate === "0001-01-01T00:00:00" ? "-" : formatDate(item.settlementDate) },
        { key: 'dealDate', header: 'Deal Date', render: (item) => item.dealDate === "0001-01-01T00:00:00" ? "-" : formatDate(item.dealDate) },
        { key: 'maturityDate', header: 'Maturity Date', render: (item) => item.maturityDate === "0001-01-01T00:00:00" ? "-" : formatDate(item.maturityDate) },
        { key: 'dateCreated', header: 'Date Created', render: (item) => item.dateCreated === "0001-01-01T00:00:00" ? "-" : formatDate(item.dateCreated) },
        { key: 'status', header: 'Status' },
    ];

    const GetBookings = async (page, pageSize, search, startDate, endDate) => {
        try {
            const response = await TreasuryBillClass.ListOfBookings(
                page, 
                pageSize, 
                search, 
                startDate, 
                endDate, 
                "LiquidationRequested"
            );
            
            if (response && response.status) {
                console.log("Treasury liquidation data:", response);
                setLiquidationData(response.data.result);
                
                // Set pagination data from API response
                setTotalPages(response.data.totalPages || 1);
                setTotalCount(response.data.totalCount || 0);
                setHasNextPage(response.data.hasNextPage || false);
                setHasPreviousPage(response.data.hasPreviousPage || false);
            } else {
                console.error("Invalid response from TreasuryBillClass.ListOfBookings");
                setLiquidationData([]);
                setTotalPages(1);
                setTotalCount(0);
                setHasNextPage(false);
                setHasPreviousPage(false);
            }
        } catch (error) {
            console.error("Error fetching treasury liquidation data:", error);
            setLiquidationData([]);
            setTotalPages(1);
            setTotalCount(0);
            setHasNextPage(false);
            setHasPreviousPage(false);
        }
    }

    useEffect(() => {
        GetBookings(pageIndex, itemsPerPage, searchLiquidations, from, to);
    }, [pageIndex, itemsPerPage, from, to, searchLiquidations]);

    const range = async (e) => {
        e.preventDefault();
        // Reset to first page when performing new search
        setPageIndex(1);
        GetBookings(1, itemsPerPage, searchLiquidations, from, to);
    }

    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event });
            setFrom(formatDate(event));
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event });
            setTo(formatDate(event));
        }
    };

    const exportCSV = async () => {
        try {
            const resp = await TreasuryBillClass.exportTreasuryBookings(
                searchLiquidations, 
                from, 
                to, 
                "LiquidationRequested"
            );
            if (resp && resp.data) {
                window.open(resp.data);
            }
        } catch (error) {
            console.error("Error exporting CSV:", error);
        }
    }

    // Define actions
    //const actions = ['View Liquidation'];

    // Handle action selection - Fixed navigation
const handleActionSelect = (action, item) => {
    if (action.toLowerCase() === 'view liquidation') {
        // Use the new route with ID as URL parameter
        navigate(`/treasury/view/${item.id}`);
    }
};
    return (
        <Layout title="Liquidations" pageTag={"treasury_bill"} current={'/liquidation'}>
            <React.Fragment>
                <main className='mt-5'>
                    <div className="sm:flex sm:items-center justify-between flex-wrap">
                        {/* Filter Section */}
                        <div className="sm:flex-auto flex items-end flex-wrap gap-3">
                            <div className=" relative rounded-md shadow-sm ">
                                <p className='text-sm leading-3 text-gray-500'>From</p>
                                <div>
                                    <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                </div>
                            </div>
                            <div className=" relative rounded-md shadow-sm ">
                                <p className='text-sm leading-3 text-gray-500'>To</p>
                                <div>
                                    <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                </div>
                            </div>
                            <div className='flex gap-3'>
                                <div className=" relative rounded-md shadow-sm ">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        name="user"
                                        id="user"
                                        value={searchLiquidations}
                                        onChange={(e) => setSearchLiquidations(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search liquidations"
                                    />
                                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                        <div className='tooltip'>
                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                            <span className="tooltiptext">Search treasury bill liquidations</span>
                                        </div>
                                    </div>
                                </div>
                                <div className=''>
                                    <button
                                        onClick={range}
                                        className='hover:text-white active:text-white inline-flex items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons Section */}
                        <div className="mt-5 sm:ml-16 sm:flex-none flex items-center gap-3">
                            <button
                                type="button"
                                onClick={exportCSV}
                                className="inline-flex items-center hover:text-white active:text-white justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>
                        </div>
                    </div>

                    {/* table */}
                    <GeneralTable
                        columns={columns}
                        data={liquidationData}
                        nextPage={hasNextPage}
                        pageIndex={pageIndex}
                        totalCount={totalCount}
                        totalPages={totalPages}
                        prevPage={prevPage}
                        setPageIndex={handleSetPageIndex}
                        //actions={actions}
                        //onActionSelect={handleActionSelect}
                    />
                </main>
            </React.Fragment>
        </Layout>
    )
}

export default TreasuryLiquidation